import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

/**
 * HomeGate — Iter 58.4
 *
 * Componente que envuelve la ruta índice ("/"). Si el usuario tiene la política
 * `dashboard.view` renderiza el Dashboard normalmente. Si no la tiene, redirige
 * al `homeRoute` que su rol tiene configurado en Roles y Políticas (fallback
 * calculado en backend por `policies.resolve_landing_route`).
 *
 * Con esto evitamos el "Acceso denegado" cuando un rol como Cajero pierde el
 * acceso al Dashboard: el sistema lo lleva automáticamente a su vista de
 * trabajo (p. ej. Cola de Órdenes para Cajero, POS para Vendedor).
 */
export default function HomeGate({ children }) {
  const { user, loading, policies, can, homeRoute } = useAuth();

  if (loading || (user && policies.length === 0)) {
    return (
      <div className="min-h-[60vh] flex items-center justify-center">
        <div className="overline" data-testid="home-gate-loading">Cargando…</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;

  if (can("dashboard.view")) return children;

  const target = homeRoute && homeRoute !== "/" ? homeRoute : "/pos";
  return <Navigate to={target} replace />;
}
